import type { SanityImageDimensions } from '@skybeam/shared-sanity';

/**
 * Gets props for Next.js Image component based on available dimensions.
 * Returns width/height if dimensions are available, otherwise returns fill.
 *
 * @param {SanityImageDimensions | null | undefined} dimensions - Image dimensions from Sanity metadata
 * @returns {Object} Props object with either { width, height } or { fill: true }
 */
export const getImageProps = (
  dimensions?: SanityImageDimensions | null,
): object => {
  if (
    dimensions?.width &&
    dimensions?.height &&
    typeof dimensions.width === 'number' &&
    typeof dimensions.height === 'number'
  ) {
    return {
      height: dimensions.height,
      width: dimensions.width,
    };
  }

  return {
    fill: true,
  };
};
